import { render, staticRenderFns } from "./CraneBasketWithBorder.vue?vue&type=template&id=4307d21e&scoped=true"
import script from "./CraneBasketWithBorder.vue?vue&type=script&lang=js"
export * from "./CraneBasketWithBorder.vue?vue&type=script&lang=js"
import style0 from "./CraneBasketWithBorder.vue?vue&type=style&index=0&id=4307d21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4307d21e",
  null
  
)

export default component.exports